import allImgPaths from "assets/images";
import useAppState from "context/useAppState";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { markEventAsFavorite } from "services/event";

interface FeteCardProps {
  event: any;
  removalIndex: any
}

const FavoriteFeteCard = (props: FeteCardProps) => {

  const navigate = useNavigate();
  const { event, removalIndex } = props;
  const [isFavorite, setIsFavorite] = useState(event?.is_favorite);

  const {
    updateBoardCallApiFlag
  } = useAppState('cardWrapper');

  const setFavorite = async (e: any, eventId: any, isFavorite: boolean) => {
    e.stopPropagation()
    await markEventAsFavorite(eventId, { is_favorite: isFavorite })
    removalIndex(eventId)
  }

  // console.log({ event })

  const handleUserImageError = (e: any) => {
    e.target.src = allImgPaths.defaultProfileImage
  }

  const DraftCard = ({ event }: any) => {
    const objective = event?.event?.objective || "";

    // Determine whether to apply line-clamp-2 class
    const isLongObjective = objective.length > 50; // Adjust the threshold as needed

    // Extract the first 50 characters of the objective
    const shortObjective = isLongObjective ? objective.substring(0, 50) : objective;

    return (
      <>
        {/* Draft Upcoming */}

        <div className='border border-[#D8D8D8] hover:shadow-xl rounded-[10px] bg-[#fff] w-[280px] flex-shrink-0 cursor-pointer'
          onClick={() => {
            updateBoardCallApiFlag(true);
            navigate(`/fete/${event?._id}`);
          }}
        >
          <div className='relative'>
            <div className='h-[190px] rounded-tl-[10px] rounded-tr-[10px] mb-2.5'>
              <img
                className={`rounded-tl-[10px] rounded-tr-[10px] w-full h-full object-cover mb-2`}
                src={allImgPaths.upcomingDraftIcon}
                alt=''
              />
            </div>
            <div className="flex items-center gap-x-2 pb-2 px-2">
              <p className="text-[#4B3BF7] text-sm font-interSemiBold">{event?.type}</p>
              <span className="text-[#344054] text-xs border border-[#EAECF0] rounded font-interMedium bg-[#F9FAFB] px-1">
                {event?.format}
              </span>
            </div>

            <h5 className='text-[#101828] font-interSemiBold text-lg px-2 pb-2 truncate max-w-96 leading-none'>
              {event?.name}
            </h5>

            <p className="text-[#475467] px-2 mb-3 line-clamp-2 h-12">
              {event?.objective || 'No description available'}
            </p>

            <div className='flex items-center gap-x-2 justify-between border-t border-[#EAECF0] pt-2 pb-2 px-2'>
              <div className='flex items-start gap-x-2'>
                <img
                  className='w-6 h-6 rounded-full'
                  src={event.userProfileImage || allImgPaths.defaultProfileImage}
                  alt=''
                  onError={(e: any) => handleUserImageError(e)}
                />
                <div>
                  <p className='text-xs text-[#667085] pt-1.5'>{event?.createdBy}</p>
                </div>
              </div>

              <div className='flex items-center gap-x-4'>
                <img
                  onClick={(e: any) => setFavorite(e, event._id, !isFavorite)}
                  className='w-6 h-6 cursor-pointer on-hover-red'
                  src={
                    event?.is_favorite ? allImgPaths.heartIconRed : allImgPaths.heartIconGrey
                  }
                  alt=''
                />
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }

  return (
    <>
      {event.is_draft && <DraftCard event={event} />}

      {
        !event?.is_draft &&
        <div className='border border-[#D8D8D8] hover:shadow-xl rounded-[10px] bg-[#fff] w-[280px] flex-shrink-0 cursor-pointer'
          onClick={() => {
            updateBoardCallApiFlag(true);
            navigate(`/fete/${event?._id}`);
          }}
        >
          <div className='relative'>
            <div className='h-[190px] rounded-tl-[10px] rounded-tr-[10px] mb-2.5'>
              <img
                className={`rounded-tl-[10px] rounded-tr-[10px] w-full h-full object-cover mb-2`}
                src={event?.image ? event.image : allImgPaths.dummyImg1}
                alt=''
              />
            </div>
            <div className="flex items-center gap-x-2 pb-2 px-2">
              <p className="text-[#4B3BF7] text-sm font-interSemiBold">{event?.type}</p>
              <span className="text-[#344054] text-xs border border-[#EAECF0] rounded font-interMedium bg-[#F9FAFB] px-1">
                {event?.format}
              </span>
            </div>
            <h5 className='text-[#101828] font-interSemiBold text-lg pb-1.5 truncate max-w-96 leading-none px-2'>
              {event?.name}
            </h5>

            <p className="text-[#475467] mb-3 line-clamp-2 h-12 px-2">
              {event?.objective || 'No description available'}
            </p>
            <div className='flex items-center gap-x-2 justify-between border-t border-[#EAECF0] pt-2 pb-2 px-2'>
              <div className='flex items-start gap-x-2'>
                <img
                  className='w-6 h-6 rounded-full'
                  src={event.userProfileImage || allImgPaths.defaultProfileImage}
                  alt=''
                  onError={(e: any) => handleUserImageError(e)}
                />
                <div>
                  <p className='text-xs text-[#667085] pt-1.5'>{event?.createdBy}</p>
                </div>
              </div>

              <div className='flex items-center gap-x-4'>
                <img
                  onClick={(e: any) => setFavorite(e, event._id, !isFavorite)}
                  className='w-6 h-6 cursor-pointer on-hover-red'
                  src={
                    event?.is_favorite ? allImgPaths.heartIconRed : allImgPaths.heartIconGrey
                  }
                  alt=''
                />
              </div>
            </div>
          </div>
        </div>
      }
    </>
  );
}

export default FavoriteFeteCard;